var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCruces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 654,
    height: 662,
    viewBox: "0 0 654 662",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 654,
    y1: 87.5,
    x2: -31,
    y2: 87.5001,
    stroke: "#D8D8D8",
    strokeOpacity: 0.21
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 654,
    y1: 203.5,
    x2: -31,
    y2: 203.5,
    stroke: "#D8D8D8",
    strokeOpacity: 0.21
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 595,
    y2: -0.5,
    transform: "matrix(-1 0 0 1 654 552)",
    stroke: "#D8D8D8",
    strokeOpacity: 0.21
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 595,
    y2: -0.5,
    transform: "matrix(-1 0 0 1 654 320)",
    stroke: "#D8D8D8",
    strokeOpacity: 0.21
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 662,
    y2: -0.5,
    transform: "matrix(5.27541e-08 1 1 -3.62187e-08 430 0)",
    stroke: "#D8D8D8",
    strokeOpacity: 0.21
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 662,
    y2: -0.5,
    transform: "matrix(5.27541e-08 1 1 -3.62187e-08 197 0)",
    stroke: "#D8D8D8",
    strokeOpacity: 0.21
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 662,
    y2: -0.5,
    transform: "matrix(5.27541e-08 1 1 -3.62187e-08 546 0)",
    stroke: "#D8D8D8",
    strokeOpacity: 0.21
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 662,
    y2: -0.5,
    transform: "matrix(5.27541e-08 1 1 -3.62187e-08 314 0)",
    stroke: "#D8D8D8",
    strokeOpacity: 0.21
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 662,
    y2: -0.5,
    transform: "matrix(5.27541e-08 1 1 -3.62187e-08 81 0)",
    stroke: "#D8D8D8",
    strokeOpacity: 0.21
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 429.88 190.287)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 418.021 202.146)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 429.88 538.918)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 418.021 550.777)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 429.88 74.0762)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 418.021 85.9346)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 429.88 422.708)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 418.021 434.566)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 429.88 306.497)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 418.021 318.355)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 197.458 190.287)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 185.6 202.146)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 197.458 538.918)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 185.6 550.777)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 197.458 74.0762)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 185.6 85.9346)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 197.458 422.708)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 185.6 434.566)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 197.458 306.497)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 185.6 318.355)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 546.09 190.287)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 534.231 202.146)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 546.09 538.918)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 534.231 550.777)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 546.09 74.0762)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 534.231 85.9346)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 546.09 422.708)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 534.231 434.566)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 546.09 306.497)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 534.231 318.355)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 313.669 190.287)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 301.811 202.146)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 313.669 538.918)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 301.811 550.777)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 313.669 74.0762)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 301.811 85.9346)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 313.669 422.708)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 301.811 434.566)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 313.669 306.497)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 301.811 318.355)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 81.248 190.287)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 69.3896 202.146)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 81.248 538.918)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 69.3896 550.777)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 81.248 74.0762)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 69.3896 85.9346)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 81.248 422.708)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 69.3896 434.566)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(0 1 1 0 81.248 306.497)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 23.2164,
    y2: -0.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 69.3896 318.355)",
    stroke: "#D8D8D8",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruces);
export default __webpack_public_path__ + "static/media/cruces.7e3360287b4c72cc19c52d925091edea.svg";
export { ForwardRef as ReactComponent };